<h2 mat-dialog-title class="dialog-title">{{'vrs-confirm-dialog.label' | transloco}}</h2>
<div mat-dialog-content>
  <p>{{'vrs-confirm-dialog.description' | transloco}}</p>
  <ul>
    <li *ngFor="let site of data.sites" class="site-list">{{ site }}</li>
  </ul>
</div>
<div mat-dialog-actions align="end">
  <button mat-button class="cancel-button" (click)="onCancel()">{{'vrs-confirm-dialog.cancel' | transloco}}</button>
  <button mat-button class="proceed-button" (click)="onProceed()">{{'vrs-confirm-dialog.proceed' | transloco}}</button>
</div>